import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 30px;
  @media screen and (max-width: 960px) {
    flex-direction: column;
    gap: 10px;
  }
`;
